// extracted by mini-css-extract-plugin
export default {"root":"DateRangePickerFree_root__VuoSc"};